import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import InfoBoxLayoutType from 'common/questionnaires/InfoBoxLayoutType';
import LocalisedMessage from 'components/Common/LocalisedMessage';

const hasContent = (intl, messageId) => !!(messageId && intl?.messages?.[messageId]);

const QuestionInformationBox = ({ reference, complexReferences, messageValues }) => {
  const intl = useIntl();

  const showSimple = reference && hasContent(intl, reference);
  const showComplex = complexReferences && complexReferences.type === InfoBoxLayoutType.ParagraphFollowedBySingleList && hasContent(intl, complexReferences.paragraph);

  return (
    <React.Fragment>
      { showSimple && <div className="information-container">
        <FontAwesomeIcon icon="info-circle" className="i-info-inactive" />
        <div className="information-text"><LocalisedMessage id={ reference } values={ messageValues } /></div>
      </div> }
      { showComplex && <div className="information-container">
        <FontAwesomeIcon icon="info-circle" className="i-info-inactive" />
        <div className="information-text">
          <p><LocalisedMessage id={ complexReferences.paragraph } /></p>
          <ul>
            {complexReferences.listReferences.map(info => <li key={ info }><LocalisedMessage id={ info } values={ messageValues } /></li>)}
          </ul>
        </div>
      </div> }
    </React.Fragment>
  );
};

QuestionInformationBox.propTypes = {
  reference: PropTypes.string,
  complexReferences: PropTypes.shape({
    type: PropTypes.number,
    paragraph: PropTypes.string,
    listReferences: PropTypes.arrayOf(PropTypes.string)
  }),
  messageValues: PropTypes.shape()
};

QuestionInformationBox.defaultProps = {
  reference: null,
  complexReferences: null,
  messageValues: {}
};

export default QuestionInformationBox;
